var exports = {
  "F2": "editHistoryItemMetadata__da2nOy",
  "Wh": "editHistoryContainer__0eLRCM",
  "gp": "editHistoryMenuButton__twBHON",
  "Ul": "scrollableEditHistoryList__tb9M-U",
  "Sw": "editorUsername__jWT-J-",
  "BV": "loadingSkeletonContainer__sAEr0L",
};

module.exports = exports;
